import React from "react";

/**
 * Klingon Trefoil / House sigil — stylised SVG inspired by the
 * Klingon Empire emblem (blade-like trefoil). Custom path, no IP.
 */
const Sigil = ({ size = 48, className = "", glow = true }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 120 120"
    className={className}
    aria-hidden="true"
    style={glow ? { filter: "drop-shadow(0 0 8px rgba(138,3,3,0.6))" } : {}}
  >
    <defs>
      <linearGradient id="sigilBronze" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#E6B836" />
        <stop offset="60%" stopColor="#C59B27" />
        <stop offset="100%" stopColor="#7a5d10" />
      </linearGradient>
      <linearGradient id="sigilBlood" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#FF2A2A" />
        <stop offset="100%" stopColor="#5a0000" />
      </linearGradient>
    </defs>
    <g transform="translate(60 60)">
      {/* Three rotated blades */}
      {[0, 120, 240].map((deg) => (
        <g key={deg} transform={`rotate(${deg})`}>
          <path
            d="M0,-46 C8,-30 12,-18 6,-4 C2,4 -2,4 -6,-4 C-12,-18 -8,-30 0,-46 Z"
            fill="url(#sigilBlood)"
            stroke="#C59B27"
            strokeWidth="1.2"
          />
          <path
            d="M0,-44 C5,-30 6,-20 2,-10 L-2,-10 C-6,-20 -5,-30 0,-44 Z"
            fill="url(#sigilBronze)"
            opacity="0.7"
          />
        </g>
      ))}
      {/* Centre boss */}
      <circle r="9" fill="#0a0000" stroke="#C59B27" strokeWidth="1.5" />
      <circle r="3.5" fill="#FF2A2A" />
    </g>
  </svg>
);

export default Sigil;
